"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotion = require("emotion");

var _checkLarge = _interopRequireDefault(require("@amzn/meridian-tokens/base/icon/check-large"));

var _minus = _interopRequireDefault(require("@amzn/meridian-tokens/base/icon/minus"));

var _exclamationPoint = _interopRequireDefault(require("@amzn/meridian-tokens/base/icon/exclamation-point"));

var _progressTrackerContext = _interopRequireDefault(require("./progress-tracker-context"));

var _icon = _interopRequireDefault(require("../icon"));

var _functional = require("./../_utils/functional");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * Circle
 */
var circleStyles = (0, _functional.memoizeByKeys)(function (_ref) {
  var diameter = _ref.diameter,
      borderRadius = _ref.borderRadius,
      borderWidth = _ref.borderWidth,
      borderColor = _ref.borderColor,
      backgroundColor = _ref.backgroundColor,
      foregroundColor = _ref.foregroundColor;
  return (0, _emotion.css)({
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: diameter,
    height: diameter,
    borderRadius: borderRadius,
    border: "".concat(borderWidth, "px solid ").concat(borderColor),
    backgroundColor: backgroundColor,
    color: foregroundColor
  });
}, ["diameter", "borderRadius", "borderWidth", "borderColor", "backgroundColor", "foregroundColor"]);

function Circle(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: circleStyles(props)
  }, props.children);
}

Circle.propTypes = process.env.NODE_ENV !== "production" ? {
  backgroundColor: _propTypes["default"].string,
  borderColor: _propTypes["default"].string,
  borderRadius: _propTypes["default"].number,
  borderWidth: _propTypes["default"].number,
  children: _propTypes["default"].node,
  diameter: _propTypes["default"].number,
  foregroundColor: _propTypes["default"].string
} : {};
/**
 * Triangle
 */

function Triangle(_ref2) {
  var borderColor = _ref2.borderColor,
      backgroundColor = _ref2.backgroundColor,
      foregroundColor = _ref2.foregroundColor;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    "aria-hidden": "true",
    focusable: "false",
    width: "24",
    height: "24",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M22.532 19.823L13.623 1.985a1.83 1.83 0 00-3.246 0L1.468 19.823C.384 21.98 1.993 23 3.001 23h18.06c.96 0 2.554-1.049 1.47-3.177z",
    fill: backgroundColor,
    stroke: borderColor,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12 17a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5z",
    fill: foregroundColor,
    fillRule: "nonzero"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12 10v4",
    stroke: foregroundColor,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

Triangle.propTypes = process.env.NODE_ENV !== "production" ? {
  backgroundColor: _propTypes["default"].string,
  borderColor: _propTypes["default"].string,
  foregroundColor: _propTypes["default"].string
} : {};
/**
 * Milestone
 */

function Milestone(props) {
  var _useContext = (0, _react.useContext)(_progressTrackerContext["default"]),
      t = _useContext.t;

  var colorState = [props.neutral ? "neutral" : "theme", props.type, props.type === "past" ? props.size : undefined, props.alert].filter(Boolean);
  var shapeProps = {
    diameter: t("milestoneDiameter", props.size),
    foregroundColor: t("milestoneForegroundColor", [props.type, props.alert]),
    backgroundColor: t("milestoneBackgroundColor", colorState),
    borderColor: t("milestoneBorderColor", colorState),
    borderRadius: t("milestoneBorderRadius"),
    borderWidth: t("milestoneBorderWidth")
  };
  var showIcon = props.showIcon && props.size === "large";
  var iconTokens = showIcon && props.type === "past" ? _checkLarge["default"] : showIcon && props.type === "present" ? _minus["default"] : null;
  return props.alert === "error" && props.size === "large" ? /*#__PURE__*/_react["default"].createElement(Circle, shapeProps, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    tokens: _exclamationPoint["default"]
  })) : props.alert === "warning" && props.size === "large" ? /*#__PURE__*/_react["default"].createElement(Triangle, shapeProps) : /*#__PURE__*/_react["default"].createElement(Circle, shapeProps, iconTokens ? /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    tokens: iconTokens
  }) : null);
}

Milestone.propTypes = process.env.NODE_ENV !== "production" ? {
  alert: _propTypes["default"].oneOf(["error", "warning", "none"]),
  neutral: _propTypes["default"].bool,
  showIcon: _propTypes["default"].bool,

  /**
   * Sets the size of the component using a preset.
   */
  size: _propTypes["default"].oneOf(["small", "large"]),
  type: _propTypes["default"].oneOf(["past", "present", "future"])
} : {};
var _default = Milestone;
exports["default"] = _default;